export default __webpack_public_path__ + "static/media/checked.9e0c72e3.svg";